module.exports = __webpack_public_path__ + "img/Super-Sam-SunHero-300-V1.a72690f0.png";